import { Namespace } from '_core/utils/ssr';

export const agencyProfileConfig = {
  i18nNamespaces: ['common', 'agency', 'briefing', 'portfolio'] as Namespace,
};
